import React from 'react';
import { useAuth } from '../context/AuthContext';
import './SettingsPage.css';

export default function ProfilePage() {
  const { user } = useAuth();
  if (!user) return null;

  return (
    <div className="settings-root">
      <h1 className="settings-title">👤 Perfil</h1>
      <div className="settings-card">
        <label className="settings-label">Usuario</label>
        <div>{user.username}</div>
        <label className="settings-label">Nombre</label>
        <div>{[user.first_name, user.last_name].filter(Boolean).join(' ') || '—'}</div>
        <label className="settings-label">Correo</label>
        <div>{user.email || '—'}</div>
        <label className="settings-label">Rol</label>
        <div>{user.is_superuser ? 'Superusuario' : user.is_staff ? 'Staff' : 'Miembro'}</div>
      </div>
    </div>
  );
}
